const GET_AZURE_SITES = 'GET_AZURE_SITES';
const GET_AZURE_SITES_SUCCESS = 'GET_AZURE_SUB_SUCCESS';
const GET_AZURE_SITES_ERROR = 'GET_AZURE_SUB_ERROR';
 
export {
  GET_AZURE_SITES, GET_AZURE_SITES_SUCCESS, GET_AZURE_SITES_ERROR
  
};
